module.exports = __webpack_public_path__ + "img/pic-preservation.ea3f2e7c.png";